import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';

/** ダイアログタイプ */
export type DialogType = 'error' | 'warn' | 'info';

/** 配送位置情報インポート失敗情報 */
export type ShipmentLocationImportFailureViewModel = {
  /** CSV行番号 */
  csvNo: string;
  /** 位置情報名 */
  locationName: string;
  /** 失敗理由 */
  message: string;
};

/** ダイアログオプション */
export type ShipmentLocationImportErrorDialogOption = {
  /** タイプ */
  type: DialogType;
  /** メッセージ */
  message: string;
  /** タイトル */
  title?: string;
  /** 操作 */
  operation?: string;
  /** 失敗データ */
  data: ShipmentLocationImportFailureViewModel[];
};

@Component({
  selector: 'app-shipment-location-import-error-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
  ],
  templateUrl: './shipment-location-import-error-dialog.component.html',
  styleUrl: './shipment-location-import-error-dialog.component.scss',
})
export class ShipmentLocationImportErrorDialogComponent {
  /** タイトル */
  public title = 'Error';

  /** メッセージ */
  public message = '';

  /** 操作 */
  public operation: string | undefined;

  /** ダイアログタイプ */
  private type: DialogType = 'error';

  /** 登録失敗一覧情報 */
  public dataSource = new MatTableDataSource<ShipmentLocationImportFailureViewModel>(
    [],
  );

  /** カラム */
  public readonly displayedColumns: string[] = ['csvNo', 'locationName', 'message'];

  /** デフォルトタイトル一覧 */
  private readonly defaultTitleList: Record<DialogType, string> = {
    info: 'Information',
    warn: 'Warning',
    error: 'Error',
  };

  /** タイトルCSSクラス一覧 */
  private readonly titleClassList: Record<DialogType, string> = {
    info: 'matp-bg-primary',
    warn: 'matp-bg-accent',
    error: 'matp-bg-warn',
  };

  /** タイトルアイコン一覧 */
  private readonly titleIconList: Record<DialogType, string> = {
    info: 'error',
    warn: 'check_circle',
    error: 'cancel',
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) data: ShipmentLocationImportErrorDialogOption,
    private dialogRef: MatDialogRef<ShipmentLocationImportErrorDialogComponent>,
  ) {
    this.type = data.type;
    this.title = data.title || this.defaultTitleList[data.type];
    this.message = data.message;
    this.operation = data.operation;
    this.dataSource.data = data.data;
  }

  /**
   * 操作を実行する
   */
  public doOperation(): void {
    this.dialogRef.close(true);
  }

  /** タイトルCSSクラス */
  public get titleClass(): string {
    return this.titleClassList[this.type];
  }

  /** タイトルアイコン */
  public get titleIcon(): string {
    return this.titleIconList[this.type];
  }
}
